const React = require("react");
const SmartBonusActionCreators = require("../../actionCreators/metadata/SmartBonusActionCreators.js");

const SmartBonusForm = React.createClass({

    componentDidMount() {
        SmartBonusActionCreators.SelectTarget('current');
    },

    render() {
        return (
            <div class="form-inline">
                Import data into Smart Bonus for :&nbsp;
                <select onChange={this.TargetChanged} name="ImportCurrentMonth" id="ImportCurrentMonth" class="form-control">
                    <option value="current">Current Month</option>
                    <option value="previous">Previous Month</option>
                </select>
            </div>
        );
    },

    TargetChanged(e) {
        console.log(e.target.value);
        SmartBonusActionCreators.SelectTarget(e.target.value);
    }
});

module.exports = SmartBonusForm;


// WEBPACK FOOTER //
// ./src/components/metadata/SmartBonusForm.jsx